"use strict";



const local ='http://localhost:3383'
const cpanel ='https://distribuidorazr.com.mx/' // cambiar por la url del sitio web.

exports.url  =  cpanel + '/api/Ncl_q3O/'; 

